@if (ondPageType() === ondPageTypes.LANDING) {
  <div>
    @switch (route()[0].path) {
      @case (ondMarketingRoutesPath.CITY_TO_CITY) {
        <div class="mr-large-y">
          <h2 class="mr-small-b font-heading-3 nordic-blue-900-text text-icon-primary font-headline-small">
            {{ 'ondMarketing.popularRoutesHeading' | finLocalization }}
          </h2>

          <div class="ond-marketing-crosslinking grid-col-12">
            <div class="ond-marketing-crosslinking-tile flex flex--column">
              @if (fromLink(); as fromLink) {
                <a
                  [finLink]="fromLink.link"
                  class="bold-type font-body-1 nordic-blue-900-text text-icon-primary no-underline underline-hover font-body-medium-bold"
                >
                  {{ 'ondMarketing.crossLinking.from' | finLocalization: { city: fromLink.locationName } }}
                  <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.ARROW_RIGHT" />
                </a>
              }
            </div>
          </div>
        </div>
      }
      @case (ondMarketingRoutesPath.FROM) {
        <div class="mr-large-y">
          <h2 class="mr-small-b font-heading-3 nordic-blue-900-text text-icon-primary font-headline-small">
            {{ 'ondMarketing.exploreRoutesHeading' | finLocalization }}
          </h2>
          <div class="ond-marketing-crosslinking grid-col-12">
            @for (link of ondLinks() | slice: 0 : linkListSliceSize; track $index) {
              <div class="ond-marketing-crosslinking-tile flex-1 flex--column">
                <a
                  [finLink]="link.link"
                  class="bold-type font-body-1 nordic-blue-900-text text-icon-primary no-underline underline-hover font-body-medium-bold"
                >
                  {{ link.originCityName }} -
                  {{ link.destinationCityName }}
                  <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.ARROW_RIGHT" />
                </a>
              </div>
            }
          </div>
        </div>
      }
      @case (ondMarketingRoutesPath.FROM_COUNTRY) {
        <div class="mr-large-y">
          <h2 class="mr-small-b font-heading-3 nordic-blue-900-text text-icon-primary font-headline-small">
            {{ 'ondMarketing.exploreRoutesHeading' | finLocalization }}
          </h2>
          <div class="ond-marketing-crosslinking grid-col-12">
            @for (link of ondLinks() | slice: 0 : linkListSliceSize; track $index) {
              <div class="ond-marketing-crosslinking-tile flex-1 flex--column">
                <a
                  [finLink]="link.link"
                  class="bold-type font-body-1 nordic-blue-900-text text-icon-primary no-underline underline-hover font-body-medium-bold"
                >
                  {{ link.originCountryName }} -
                  {{ link.destinationCountryName }}
                  <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.ARROW_RIGHT" />
                </a>
              </div>
            }
          </div>
        </div>
      }
      @case (ondMarketingRoutesPath.COUNTRY_TO_COUNTRY) {
        <div class="mr-large-y">
          <h2 class="mr-small-b font-heading-3 nordic-blue-900-text text-icon-primary font-headline-small">
            {{ 'ondMarketing.popularRoutesHeading' | finLocalization }}
          </h2>

          <div class="ond-marketing-crosslinking grid-col-12">
            <div class="ond-marketing-crosslinking-tile flex flex--column">
              @if (fromCountry(); as fromCountry) {
                <a
                  [finLink]="fromCountry.link"
                  class="bold-type font-body-1 nordic-blue-900-text text-icon-primary no-underline underline-hover font-body-medium-bold"
                >
                  {{ 'ondMarketing.crossLinking.from' | finLocalization: { city: fromCountry.locationName } }}
                  <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.ARROW_RIGHT" />
                </a>
              }
            </div>
          </div>
        </div>
      }
      @default {
        <div class="mr-large-y">
          @if (ondLinks().length) {
            <h2 class="mr-small-b font-heading-3 nordic-blue-900-text text-icon-primary font-headline-small">
              {{ 'ondMarketing.exploreRoutesHeading' | finLocalization }}
            </h2>
            <div class="ond-marketing-crosslinking grid-col-12">
              @for (link of ondLinks() | slice: 0 : linkListSliceSize; track $index) {
                <div class="ond-marketing-crosslinking-tile flex-1 flex--column">
                  <a
                    [finLink]="link.link"
                    class="bold-type font-body-1 nordic-blue-900-text text-icon-primary no-underline underline-hover font-body-medium-bold"
                  >
                    {{ link.originCityName }} -
                    {{ link.destinationCityName }}
                    <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.ARROW_RIGHT" />
                  </a>
                </div>
              }
            </div>
          }
        </div>
      }
    }
  </div>
}

@if (ondPageType() === ondPageTypes.LISTING) {
  <div>
    @switch (route()[0].path) {
      @case (ondMarketingRoutesPath.CITY_TO_CITY) {
        <div class="mr-large-y">
          <div class="ond-marketing-crosslinking grid-col-12">
            @for (link of ondLinks(); track $index) {
              <div class="ond-marketing-crosslinking-tile flex-1 flex--column">
                <a
                  [finLink]="link.link"
                  class="bold-type font-body-1 nordic-blue-900-text text-icon-primary no-underline underline-hover font-body-medium-bold"
                >
                  {{ link.originCityName }} -
                  {{ link.destinationCityName }}
                  <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.ARROW_RIGHT" />
                </a>
              </div>
            }
          </div>
        </div>
      }
      @case (ondMarketingRoutesPath.FROM_COUNTRY) {
        <div class="mr-large-y">
          <div class="ond-marketing-crosslinking grid-col-12">
            @if (fromCountry(); as fromCountry) {
              <div class="ond-marketing-crosslinking-tile flex flex--column">
                @if (fromCountry.link) {
                  <a
                    [finLink]="fromCountry.link"
                    class="bold-type font-body-1 nordic-blue-900-text text-icon-primary no-underline underline-hover font-body-medium-bold"
                  >
                    {{ 'ondMarketing.crossLinking.from' | finLocalization: { city: fromCountry.locationName } }}
                    <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.ARROW_RIGHT" />
                  </a>
                }
              </div>
            }
          </div>
        </div>
      }
      @case (ondMarketingRoutesPath.COUNTRY_TO_COUNTRY) {
        <div class="mr-large-y">
          <div class="ond-marketing-crosslinking grid-col-12">
            @for (link of ondLinks(); track $index) {
              <div class="ond-marketing-crosslinking-tile flex-1 flex--column">
                <a
                  [finLink]="link.link"
                  class="bold-type font-body-1 nordic-blue-900-text text-icon-primary no-underline underline-hover font-body-medium-bold"
                >
                  {{ link.originCountryName }} -
                  {{ link.destinationCountryName }}
                  <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.ARROW_RIGHT" />
                </a>
              </div>
            }
          </div>
        </div>
      }
      @case (ondMarketingRoutesPath.FROM) {
        <div class="mr-large-y">
          <div class="ond-marketing-crosslinking grid-col-12">
            @for (link of ondLinks(); track $index) {
              <div class="ond-marketing-crosslinking-tile flex-1 flex--column">
                <a
                  [finLink]="link.link"
                  class="bold-type font-body-1 nordic-blue-900-text text-icon-primary no-underline underline-hover font-body-medium-bold"
                >
                  {{ 'ondMarketing.crossLinking.from' | finLocalization: { city: link.originCityName } }}
                  <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.ARROW_RIGHT" />
                </a>
              </div>
            }
          </div>
        </div>
      }
    }
  </div>
}
